import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { IconEdit } from '../../../../../../assets/icons/icon-edit';
import { DialogTimePicker, InputMui } from '../../../../../../components';
import Info from '../../../../../../components/channel-configuration/info';
import { millisecondsToTime } from '../../../../../../utils/helpers';
import { ChannelGateType, ChannelType } from '../../../../types';

type SignalTimeProps = {
  channel: ChannelType;
  handleSave: (time: string) => void;
};

const TiltTime: React.FC<SignalTimeProps> = ({ channel, handleSave }) => {
  const { t } = useTranslation('configuration');
  const [showTimePicker, setShowTimePicker] = useState<boolean>(false);
  const tiltTimeInMs = millisecondsToTime((channel.data as ChannelGateType).tiltTimeInMs || 0);

  return (
    <>
      <hr />
      <Info title={t('tiltTime')} />
      <InputMui
        value={tiltTimeInMs}
        readOnly
        onClickInput={() => setShowTimePicker(true)}
        endIcon={<IconEdit />}
      />
      <DialogTimePicker
        header={`${t('tiltTime')} (mm:ss)`}
        open={showTimePicker}
        setOpen={setShowTimePicker}
        onSave={(value) => handleSave(value)}
        time={tiltTimeInMs}
        showSeconds
        disableHours
        minSeconds={1}
        maxMinutes={1}
      />
    </>
  );
};

export default TiltTime;
